import {Injectable} from '@angular/core';
import * as XLSX from 'xlsx';
import {SheetJSONOpts} from 'xlsx';
import moment from "moment";

import {NotifyService} from "./notify.service";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";


import {
  concatMap, defaultIfEmpty, defer, EMPTY, expand, finalize, from, last,
  map, Observable, of, Subject, takeUntil, tap
} from "rxjs";


import {Params} from "@angular/router";

import {NgxPermissionsService} from "ngx-permissions";
import {API_NHANH_KEY} from "@core/constants";
import {IDataExportSpreadData, IResponseApi, V2ApiResponseError} from '@core/models';

import {NgxModalCustomService} from '@shared/services/global/ngx-modal-custom.service';
import {LoggingService} from '@shared/services/api/logging';
import {AppService} from '@core/services/app.service';
import {NavService} from '@core/services/nav.service';
import {AuthService} from "@core/authentication/auth.service";
import {FormatNumberPipe, FormatPercentPipe} from '@shared/pipes/global';
import {ExportExcelModalComponent} from '@shared/components/excel/export-excel.component';
import {castInt, ceilDivision, createRangePage, isArray, translateColumnNames} from '@shared/utils';
import {FILE_NAME_DATE_FORMAT} from '@shared/constants';
import {saveAs} from 'file-saver';
import {
  GOOGLE_SHEET_AUTH_CODE_PARAM,
  GOOGLE_SHEET_OPEN_MODAL_EXPORT,
  IConfigExportDataGoogleSheet,
  IGoogleSheetExportCell,
  IResExportDataGGS
} from '@shared/models/business';
import {GoogleSheetService} from '@shared/services/api/business/google-sheet.service';
import {IDisplayColumn} from '@shared/models/idb';
import {
  ExportDataExcelSettingModalComponent,
  IOptionsExportDataExcelSetting
} from '@shared/components/excel/export-data';
import {ImportExcelModalComponent} from '@shared/components/excel/import-excel';
import {GoogleSheetExportComponent} from '@shared/components/google-sheet/google-sheet-export.component';
import type {ExportDataSettingBase} from '@shared/components/export-data/export-data-setting.base';


type IExportExcel = {
  jsonData: any[],
  fileName: string,
  sheetName?: string,
  heading?: string[],
  header?: string[], // Danh sách các key (ref) cần lấy dữ liệu
  notSuffixFileName?: boolean
}
export type IExportExcelAndLog = IExportExcel & {
  typeExport: number
};

interface Paginator {
  icpp: number;
  currentPage: number;
  totalPage: number;
  totalItem: number;
  currentRow: number;
}

interface Log {
  error: Record<string, any>;
  warning: Record<string, any>;
  success: Record<string, any>;
}

interface optionsImport {
  MSG_PROCESSING_ERROR: string;
  MSG_FILE_ERROR: string;
  items: any[];
  file: File | null;
  url: string;
  sheetName: string;
  workbook: Record<string, any>;
  header: Record<string, any>;
  saveFileImport: boolean;
  stop: boolean;
  fileElementName: string;
  importId: string;
  paginator: Paginator;
  formParam: Record<string, any>;
  log: Log;
  totalSuccess: number;
  totalWarning: number;
  totalError: number;
}

// Sử dụng optionsImport như biến có kiểu đã định nghĩa
export type IProgressPaginator = {
  totalPages: number,
  totalItems: number,
  pageSize: number,
  page: number,
  resultData?: any,
  isError?: boolean,
  isDone?: boolean,
  currentItem?: number,
  spreadData?: IDataExportSpreadData,
}
type SubjectEventExcelService = {
  type: 'error' | string,
  res: IResponseApi<any>
}

// Interface export data -----------------------------------------------------------------------------------------------
export type IOptsCallbackFuncExportData = {
  setting: IConfigExportDataGoogleSheet,
  excelService: ExcelService,
}
type ICallbackFuncHandle = (data: any, opts: IOptsCallbackFuncExportData) => any
export type TFinalExportDataOpts = {
  params: Params, // Params custom
  service: any, // DI service
  func: string, // Function trong service call API
  outputSetting: IConfigExportDataGoogleSheet,
  // Hàm callback nhận dữ liệu trả lại dữ liệu cần export
  callbackFuncHandle: ICallbackFuncHandle,

  // Hiện tại chưa có case dùng page nên tạm ẩn đi
  pageStart?: number | string | any[], // Page trang hiện tại string cho elPage | number cho mysql | any[] cho elastic next
  pageSize: number, // Giới hạn số lượng bản ghi trên trang
  totalItems?: number, // Tổng số lượng dữ liệu

  /**
   * Các tình huống sau chỉ mà ở client đã đủ dữ liệu để xuất ra thì tạo excelData để xuất file được luôn
   * - Xuất dữ liệu theo "các dòng đã chọn"
   * - Xuất dữ liệu "trang hiện tại"
   * */
  excelData?: any[], // Dữ liệu export
  excelHeaders?: string[], // string headers
  /*
  * Giới hạn số lượng bản ghi tối đa được export vd: EXCEL_EXPORT_LIMITS.FOR_CSV
  * Dùng với tab "Excel"
  * */
  limitNumberExport?: number,

  // Lưu log export data, chưa có thì cần khai thêm const
  typeLogExport: number,

  // Dùng với xuất dữ liệu "trang hiện tại" nhưng cần lấy thêm data chỉ với có format excel mới trả về
  isOnePage?: boolean,

  // Dùng cho case gửi ids lên theo dạng mảng, không cần join để gửi lên dạng string
  idsSimple?: boolean,

  // Số lượng dữ liệu xuất theo "bản ghi đã chọn" | "trang hiện tại"
  exportRecordTotal?: number
}

// End Interface export data -----------------------------------------------------------------------------------------------

export type IExcelExportSelection = {
  config: TFinalExportDataOpts;
  paramIdsName?: string;
  paths?: string[];
  dataSourceExtra?: any[],
  isElasticSearch?: boolean // Export sử dụng data ES
}

export type IExportDataSelection = {
  config: TFinalExportDataOpts; // Dùng tạm TFinalExportDataOpts khi chưa có TExportDataOptsVersion2
  paramIdsName?: string;
  paths?: string[];
  dataSourceExtra?: any[],
  isElasticSearch?: boolean // Export sử dụng data ES
  skipValid?: boolean // Sử dụng cho những trang xuất data ko hỗ trợ dạng ids
}

/**
 * Class xử lý dữ liệu lưu Local Storage
 * - Dữ liệu sẽ lưu theo domain.
 * - Dữ liệu chỉ bị xóa khi sử dụng event để xóa hoặc xóa cache trình duyệt
 * */
@Injectable({
  providedIn: 'any',
})
export class ExcelService {
  fileExtension = '.xlsx';
  subjectEvent$ = new Subject<SubjectEventExcelService>();
  progressPaginator = new Subject<IProgressPaginator | null>();
  exportSuccess = new Subject<boolean>();
  shouldContinue = true;
  private googleSheetExportStop$ = new Subject<void>();
  private isGoogleSheetExporting = false;

  optionsImport: optionsImport = this._createOptionsImport();

  refModal: NgbModalRef | null | any = null;
  private _refModalExportData!: ExportDataSettingBase;

  hasOpenModal = true; // Biến đánh dấu mặc định mở modal, không dùng modal chung thì set false
  constructor(
    private notifyService: NotifyService,
    private ngbModal: NgxModalCustomService,
    private loggingService: LoggingService,
    private navService: NavService,
    private app: AppService,
    private auth: AuthService,
    private permissionsService: NgxPermissionsService,
    public formatNumber: FormatNumberPipe,
    public formatPercent: FormatPercentPipe,
    private googleSheetService: GoogleSheetService
  ) {

  }

  hasExcelPermission(permission: string): boolean {
    const permissions = this.permissionsService.getPermissions();
    return !!permissions[permission];
  }

  closeAllModal() {
    this.ngbModal.dismissAll();
  }

  /**
   * -----------------------------------------------------------------------------------------------------------------
   * Export Data handle (Excel file | Googl Sheet) -------------------------------------------------------------------------------------------------
   * -----------------------------------------------------------------------------------------------------------------
   * */
  checkOpenExportDataSetting() {
    const authCode = !!this.navService.getParam(GOOGLE_SHEET_AUTH_CODE_PARAM);
    const isOpen = !!this.navService.getParam(GOOGLE_SHEET_OPEN_MODAL_EXPORT);
    return authCode || isOpen;
  }

  /**
   * Mở modal export data
   * - Chú tất cả các key label hay hiển thị tên cần truyền key translate
   * @Docs:
   * - https://docs.google.com/document/d/1tGwUmV8q-NtGCP4VLkiTuIdaJRiOh_upHgnU7YQFxCg/edit#heading=h.rv1ly6gyf1qw
   * */
  openExportDataModal(opts: IOptionsExportDataExcelSetting, destroy: Subject<any>) {
    if (!opts || !opts.businessId) {
      return;
    }

    opts.excelService = this;
    if (!opts.excelListPage) {
      opts.excelListPage = {
        checked: 'recordAll',
        list: [
          {
            key: 'recordAll',
            value: 'common.allPages',
          }
        ]
      }
    }

    const exportType = opts.exportType ?? (this.navService.getParam('tabRef') === 'googleSheets' ? 'googleSheets' : 'excel');
    const component = exportType === 'googleSheets' ? GoogleSheetExportComponent : ExportDataExcelSettingModalComponent;
    const modalRef = this.ngbModal.openDefault(component, {size: 'lg'});
    const refInstance = modalRef.componentInstance as ExportDataSettingBase;
    refInstance.options = opts;

    modalRef.dismissed.subscribe({
      next: () => {
        this.navService.removeParams(['isOpenExportGG', 'tabRef', 'tokenError'])
        this.stopExcelPaging()
      }
    })

    this.exportSuccess.pipe(takeUntil(destroy), takeUntil(refInstance.appForm.destroyed)).subscribe({
      next: success => {
        if (success) {
          modalRef.close();
        }
      }
    })

    this._refModalExportData = refInstance;

    return refInstance;
  }

  get refModalExportData() {
    return this._refModalExportData;
  }

  /*
  * End Export Data handle (Excel file | Googl Sheet) ---------------------------------------------------------------------------
  * */


  /**
   * -----------------------------------------------------------------------------------------------------------------
   * Export handler -------------------------------------------------------------------------------------------------
   * -----------------------------------------------------------------------------------------------------------------
   * */
  startExcelPaging() {
    this.shouldContinue = true;
  }

  stopExcelPaging() {
    this.shouldContinue = false;
    this.googleSheetExportStop$.next();
  }

  // Export file & lưu log export
  startExportPaginator(onlyPageCurrent = false) {
    const refModal = this.ngbModal.openDefault(ExportExcelModalComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    })
    refModal.componentInstance.service = this;
    refModal.componentInstance.onlyPageCurrent = onlyPageCurrent;
    refModal.closed.subscribe({
      next: (isClose: boolean | undefined) => {
        if (isClose) {
          this.onExportSuccess()
        }
      }
    })
    this.exportSuccess.subscribe({
      next: success => {
        if (success) {
          this.ngbModal.dismissAll();
        }
      }
    })
  }

  /**
   * Chỉ export file, không lưu log
   * */
  exportExcelOnly(configs: IExportExcel, options?: Record<string | 'useFileNew', any>) {
    let {jsonData} = configs;
    const {heading, notSuffixFileName} = configs;
    let {fileName, sheetName} = configs;
    // ko có data vẫn cho xuất excel ra, như bản cũ
    if (!isArray(jsonData)) {
      this.notifyService.warning('common.messages.invalidData')
      return false;
    }
    sheetName = sheetName ? sheetName : 'data';

    // Had to create a new workbook and then add the header
    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    const opts: SheetJSONOpts = {};
    if (heading && heading) {
      XLSX.utils.sheet_add_aoa(ws, [heading]);
      opts.origin = 'A2';
      opts.skipHeader = true;
    }

    // Chỉ lấy các trường dữ liệu nằm trong danh sách header nếu có
    if (configs.header && configs.header.length > 0) {
      jsonData = jsonData.map(item => {
        const filtered: any = {};
        configs.header!.forEach(key => {
          filtered[key] = item[key];
        });
        return filtered;
      });
      opts.header = configs.header;
    }

    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, jsonData, opts);

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // Không phải tên user sửa thì mới nối
    if ((!options || !options['useFileNew']) && !notSuffixFileName) {
      fileName += `_${moment().format(FILE_NAME_DATE_FORMAT)}`;
    }

    XLSX.writeFile(wb, fileName + this.fileExtension);

    // Export when close modal
    this.onExportSuccess();

    return true;
  }

  /**
   * Export file and save log
   * */
  exportExcel(configs: IExportExcelAndLog, options?: Record<string | 'useFileNew', any>) {
    const {jsonData, fileName, sheetName, heading, notSuffixFileName} = configs;
    if (!configs.typeExport) {
      // Nếu không có cấu hình log (ví dụ các dự án mới chưa triển khai log), chỉ xuất file và bỏ qua việc lưu log
      return this.exportExcelOnly(configs, options);
    }

    const handler = this.exportExcelOnly(configs, options);
    if (!handler) {
      return false;
    }

    // this.loggingService.saveLogExportExcel({
    //   type: configs.typeExport,
    //   totalRows: jsonData.length,
    //   link: this.navService.currentUri,
    //   businessId: this.auth.businessCurrent?.id ?? 0,
    // }).subscribe();
    return true
  }

  onExportSuccess() {
    this.exportSuccess.next(true);
  }

  /**
   * -----------------------------------------------------------------------------------------------------------------
   * Import handler -------------------------------------------------------------------------------------------------
   * -----------------------------------------------------------------------------------------------------------------
   * */
  private _createOptionsImport(): optionsImport {
    return {
      MSG_PROCESSING_ERROR: 'Có lỗi trong quá trình thực hiện',
      MSG_FILE_ERROR: 'File không đúng format mẫu hoặc không có dữ liệu',

      items: [],
      file: null,
      url: '',
      sheetName: '',
      workbook: {},
      header: {},
      saveFileImport: true,
      stop: false,
      fileElementName: 'fileUpload',
      importId: '',
      paginator: {
        icpp: 50,
        currentPage: 1,
        totalPage: 0,
        totalItem: 0,
        currentRow: 2,
      },
      formParam: {},
      log: {
        error: {},
        warning: {},
        success: {}
      },
      totalSuccess: 0,
      totalWarning: 0,
      totalError: 0,
    }
  }

  openModal() {
    if (this.hasOpenModal) {
      this.refModal = this.ngbModal.openDefault(ImportExcelModalComponent, {
        size: 'md',
        centered: true,
        backdrop: 'static'
      })
      this.refModal.dismissed.subscribe({
        next: () => {
          this.optionsImport.stop = true
        }
      })
    }

  }

  closeModal() {
    if (this.refModal) {
      this.refModal.close()
    }
  }

  setDataModal(data: any) {
    if (this.refModal) {
      Object.keys(data).forEach((k: any) => {
        if (this.refModal) {
          this.refModal.componentInstance[k] = data[k]
        }
      })
    }
  }

  setHasOpenModal(value: boolean) {
    this.hasOpenModal = value;
  }

  stopImportExcel() {
    this.optionsImport.stop = true;
  }

  errorHandler(messages: string | string[]) {
    this.notifyService.error(messages)
    this.optionsImport.stop = true
    this.closeModal()
    return;
  }

  resetOptionsImport() {
    this.optionsImport.items = []
    this.optionsImport.file = null
    this.optionsImport.url = ''
    //this.optionsImport.sheetName = '' , không reset sheetName
    this.optionsImport.workbook = {}
    this.optionsImport.header = {}
    this.optionsImport.saveFileImport = true
    this.optionsImport.stop = false
    this.optionsImport.fileElementName = 'fileUpload'
    this.optionsImport.importId = ''
    this.optionsImport.formParam = {}
    this.optionsImport.log = {
      error: {},
      warning: {},
      success: {}
    }
    this.optionsImport.totalSuccess = 0
    this.optionsImport.totalWarning = 0
    this.optionsImport.totalError = 0
    this.hasOpenModal = true
  }

  loadFile(file: File) {
    this.resetOptionsImport()
    const reader: FileReader = new FileReader()
    reader.onload = (e: any) => {
      /* create workbook */
      const binaryStr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryStr, {type: 'binary'})
      const rows: any = {}
      const sheetName = this.optionsImport.sheetName
      if (typeof workbook != 'undefined' && typeof workbook.Sheets != 'undefined'
        && typeof workbook.Sheets[sheetName] != 'undefined') {
        for (const i in workbook.Sheets[sheetName]) {
          if (i.charAt(0) == '!') {
            continue
          }
          const cell = workbook.Sheets[sheetName][i]
          const cellAddress = XLSX.utils.decode_cell(i)
          if (typeof rows[cellAddress.r] == 'undefined') {
            rows[cellAddress.r] = {}
          }
          rows[cellAddress.r][cellAddress.c] = cell.v

        }
      } else {
        return this.errorHandler([this.optionsImport.MSG_FILE_ERROR])
      }
      this.optionsImport.header = rows[0]
      delete rows[0]
      this.toItems(rows)

    }
    reader.readAsBinaryString(file)
    this.optionsImport.file = file
  }

  toItems(rows: any) {
    const items: any = {}
    let index = 2
    if (rows) {
      for (const i in rows) {
        if (rows[i]) {
          const item: any = {}
          let isValid = false
          for (const col in rows[i]) {
            if (col in this.optionsImport.header) {
              item[this.optionsImport.header[col]] = rows[i][col]
            }
            if (rows[i][col]) {
              isValid = true
            }
          }
          if (isValid) {
            items[index] = item
          }
        }
        index++
      }
    }
    if (index <= 2) {
      return this.errorHandler([this.optionsImport.MSG_FILE_ERROR])
    }
    this.optionsImport.items = items
    this.toPaginator()
  }

  toPaginator() {
    this.resetPaginator()
    const totalItem = Object.keys(this.optionsImport.items).length
    if (totalItem) {
      this.optionsImport.paginator.totalItem = totalItem
      const x = this.optionsImport.paginator.totalItem / this.optionsImport.paginator.icpp;
      this.optionsImport.paginator.totalPage = Math.ceil(x)
    }
  }

  resetPaginator() {
    this.optionsImport.paginator.currentPage = 1
    this.optionsImport.paginator.currentRow = 2
    this.optionsImport.paginator.totalItem = 0
    this.optionsImport.paginator.totalPage = 0
  }

  /**
   * click import
   * @param param
   * @deprecated
   * @TODO NVN: chuyển sang dùng riêng ImportExcelService
   */
  start(param: any) { //
    if (param) {
      this.optionsImport.formParam = param
    }
    this.optionsImport.log = {
      error: {},
      warning: {},
      success: {}
    }
    this.toPaginator()
    this.openModal()

    // post trước lên 1 lần để validate các dữ liệu
    const formParam = new FormData()
    for (const paramName in this.optionsImport.formParam) {
      formParam.append(paramName, this.optionsImport.formParam[paramName])
    }
    if (this.optionsImport.saveFileImport && this.optionsImport.file) {
      formParam.append(this.optionsImport.fileElementName, this.optionsImport.file)
    }
    formParam.append('isPrepair', '1')
    formParam.append('totalRows', this.optionsImport.paginator.totalItem.toString())
    this.optionsImport.stop = false

    if (this.optionsImport.url) {
      this.postFirstImportExcel(formParam).subscribe({
        next: (rs) => {
          if (rs.code) {
            if (!this.optionsImport.stop) {
              if (rs.data?.importId) {
                this.optionsImport.importId = rs.data.importId
              }
              if (rs.data?.extendParam) {
                this.optionsImport.formParam = {...this.optionsImport.formParam, ...rs.data.extendParam}
              }
              this.processing()
            }
          } else {
            this.notifyService.error(rs.messages?.[0] ?? this.optionsImport.MSG_PROCESSING_ERROR)
          }
        },
        error: (e) => {
          this.errorHandler(e)
        }
      })
    } else {
      this.errorHandler('common.invalidUrl')
    }
  }

  finishModal() {
    this.optionsImport.stop = true
    this.setDataModal({finish: true})
  }

  /**
   * chạy tiến trình import
   * hiển thị ra modal
   * @param options
   */
  processing(options: any | null = null) {
    if (this.optionsImport.stop) {
      return
    }
    if (this.optionsImport.paginator.currentPage > this.optionsImport.paginator.totalPage
      || this.optionsImport.paginator.currentRow > this.optionsImport.paginator.totalItem + 1) {
      return this.finishModal()
    }
    let startItemIndex = this.optionsImport.paginator.currentRow
    let endItemIndex = startItemIndex + this.optionsImport.paginator.icpp - 1
    if (endItemIndex > this.optionsImport.paginator.totalItem + 1) {
      endItemIndex = this.optionsImport.paginator.totalItem + 1
    }
    const items: any = {};
    for (startItemIndex; startItemIndex <= endItemIndex; startItemIndex++) {
      if (startItemIndex in this.optionsImport.items) {
        items[startItemIndex] = this.optionsImport.items[startItemIndex];
      }
    }
    const params = {
      ...this.optionsImport.formParam, ...{
        'rows': JSON.stringify(items),
        'page': this.optionsImport.paginator.currentPage,
        'totalPage': this.optionsImport.paginator.totalPage,
        'totalRows': this.optionsImport.paginator.totalItem,
        'icpp': this.optionsImport.paginator.icpp,
        'start': this.optionsImport.paginator.currentRow,
        'importId': this.optionsImport.importId,
      }
    }
    if (this.optionsImport.url) {
      this.processingImport(params).subscribe({
        next: (rs) => {
          if (rs.code) {
            this.optionsImport.paginator.currentRow = startItemIndex
            this.optionsImport.paginator.currentPage++
            // ghi ra log
            this.writeLog(rs.data)
            this.changeModalStage()
            if (rs.data && rs.data?.extendParam) {
              this.optionsImport.formParam = {...this.optionsImport.formParam, ...rs.data.extendParam}
            }

            if (options && options?.delay && parseInt(options?.delay)) {
              setTimeout(() => {
                this.processing(options)
              }, options.delay)
            } else {
              this.processing()
            }
          } else {
            this.optionsImport.stop = true
            this.notifyService.error(rs.messages?.[0] ?? this.optionsImport.MSG_PROCESSING_ERROR)
          }
        },
        error: (e: Error) => {
          this.errorHandler(e.message)
        }
      })
    } else {
      this.errorHandler('common.invalidUrl')
    }
  }

  /**
   * hiển thị log ra modal
   * status: 1 thành công, 2 cảnh báo, 3 thất bại
   * @param obj
   */
  writeLog(obj: any) {
    const logs: any = []
    if (obj && obj?.rowsSuccess) {
      for (const i in obj.rowsSuccess) {
        this.optionsImport.log.success[i] = obj.rowsSuccess[i]
        logs.push({line: i, status: 1, msg: obj.rowsSuccess[i]})
      }
    }

    if (obj && obj?.rowsWarning) {
      for (const i in obj.rowsWarning) {
        this.optionsImport.log.warning[i] = obj.rowsWarning[i]
        logs.push({line: i, status: 2, msg: obj.rowsWarning[i]})
      }
    }

    if (obj && obj?.rowsError) {
      for (const i in obj.rowsError) {
        this.optionsImport.log.error[i] = obj.rowsError[i]
        logs.push({line: i, status: 3, msg: obj.rowsError[i]})
      }
    }

    // cho hiển thị ra log vào content modal
    this.optionsImport.totalSuccess = Object.keys(this.optionsImport.log.success).length
    this.optionsImport.totalError = Object.keys(this.optionsImport.log.error).length
    this.optionsImport.totalWarning = Object.keys(this.optionsImport.log.warning).length
    this.setDataModal({
      logs: logs,
      totalSuccess: this.optionsImport.totalSuccess,
      totalError: this.optionsImport.totalError,
      totalWarning: this.optionsImport.totalWarning,
    })
  }


  /**
   * Hiển thị trạng thái thanh tiến trình đang chạy
   * thống kê các trạng thái import
   */
  changeModalStage() {
    this.setDataModal({
      totalImported: this.optionsImport.paginator.currentRow - 2, // trừ đi 1 dong header,1 dòng lấy lúc đầu
      totalRecord: this.optionsImport.paginator.totalItem,
    })
  }


  postFirstImportExcel = (formParam: FormData) => {
    return this.loggingService.postFormDataRequest<IResponseApi<any>>(this.optionsImport.url, formParam)
  }

  processingImport = (params = {}) => {
    return this.loggingService.postRequest<IResponseApi<any>>(this.optionsImport.url, params)
  }

  saveLog() {
    let logContent = '';
    const date = new Date();
    const month = date.getMonth() + 1;
    logContent += "Import time: "
      + date.getFullYear() + "-"
      + month + "-"
      + date.getDate() + " "
      + date.getHours() + ":"
      + date.getMinutes() + ":"
      + date.getSeconds() + "\n\n";

    if (typeof this.optionsImport.log.success != 'undefined') {
      logContent += "===================Thành công==============\n";
      for (const i in this.optionsImport.log.success) {
        logContent += "Dòng " + i + "\n";
      }
      logContent += "\n\n";
    }

    if (typeof this.optionsImport.log.warning != 'undefined') {
      logContent += "===================Cảnh báo==============\n";
      for (const i in this.optionsImport.log.warning) {
        logContent += "Dòng " + i + "\n";
        for (const j in this.optionsImport.log.warning[i]) {
          logContent += " - " + this.optionsImport.log.warning[i][j] + "\n";
        }
        logContent += "\n";
      }
      logContent += "\n\n";
    }

    if (typeof this.optionsImport.log.error != 'undefined') {
      logContent += "===================Lỗi==============\n";
      for (const i in this.optionsImport.log.error) {
        logContent += "Dòng " + i + "\n";
        for (const j in this.optionsImport.log.error[i]) {
          logContent += " - " + this.optionsImport.log.error[i][j] + "\n";
        }
        logContent += "\n";
      }
      logContent += "\n\n";
    }


    let name = 'log_import_' + date.getFullYear() + "_" + month + "_" + date.getDate();
    name += "_" + date.getHours() + "_" + date.getMinutes() + "_" + date.getSeconds() + ".txt";

    saveAs(new Blob([logContent], {type: "text/plain;charset=utf-8"}), name);
  }


  /**
   * ------------------------------------------------------------------------------------------------------------------
   * Export data handle -----------------------------------------------------------------------------------------------
   * ------------------------------------------------------------------------------------------------------------------
   * */
  onHandleElasticExportData(opts: TFinalExportDataOpts): void {
    return this.onHandleExportData(opts, true);
  }

  onHandleExportData(opts: TFinalExportDataOpts, isElasticSearch = false): void {
    const {outputSetting: setting} = opts;
    if (!setting.columns || typeof opts != "object" || typeof opts.service == undefined ||
      // Thiếu func service call API
      typeof opts.service?.[opts.func] === undefined ||
      // Thiếu func tạo dữ liệu
      (!opts.callbackFuncHandle || typeof opts.callbackFuncHandle !== "function")) {
      this.stopExcelPaging();
      this.refModalExportData.progressState.isExportSubmit = false;
      return this.notifyService.warning('common.messages.invalidData');
    }
    if (setting.tabRef == 'excel') {
      return this.onHandleExportTabExcel(opts, isElasticSearch);
    }

    this.onHandleExportTabGoogleSheet(opts, isElasticSearch);
  }

  private onHandleExportTabGoogleSheet(opts: TFinalExportDataOpts, isElasticSearch: boolean): void {
    if (this.isGoogleSheetExporting) return;

    const setting = opts.outputSetting;
    const allColumns = setting.columns.flatMap(col => col.childs?.length ? col.childs : [col]);
    const columns = allColumns.filter(col => col.display);
    let headers = opts.excelHeaders?.length ? [...opts.excelHeaders] : translateColumnNames(columns, this.app);
    if (opts.excelHeaders?.length === allColumns.length && allColumns.length) {
      headers = allColumns.flatMap((col, index) => col.display ? [opts.excelHeaders![index]] : []);
    }
    if (!headers.length || (columns.length && headers.length !== columns.length)) {
      this.refModalExportData.progressState.isExportSubmit = false;
      this.notifyService.warning('common.messages.invalidData');
      return;
    }

    this.isGoogleSheetExporting = true;
    this.startExcelPaging();
    const hasLocalData = Array.isArray(opts.excelData);
    const isOnePage = hasLocalData || !!opts.isOnePage ||
      ['recordPage', 'recordSelected'].includes(setting.pageSelection);
    const pageSize = Math.max(1, castInt(opts.pageSize) || 250);
    let page = setting.pageSelection === 'recordPage' && !isElasticSearch
      ? Math.max(1, castInt(opts.pageStart)) : 1;
    const params: any = {
      ...opts.params,
      format: 'jsExcel',
      formatNewExportExcel: 'excelStatic',
    };
    if (isElasticSearch) {
      params.size = pageSize;
      params[API_NHANH_KEY.EL_PAGE] = setting.pageSelection === 'recordPage'
        ? (opts.pageStart ?? []) : [];
    } else {
      params.icpp = pageSize;
      params.page = page;
    }

    let spreadData: IDataExportSpreadData | null = null;
    const progress: IProgressPaginator = {
      page: 0, pageSize, totalPages: 0, totalItems: opts.totalItems ?? 0,
      currentItem: 0, isDone: false, isError: false,
    };
    const seenCursors = new Set<string>();
    type PageResult = {next: any; hasNext: boolean};

    const loadPage = (): Observable<PageResult> => {
      const request: Observable<IResponseApi<any>> = hasLocalData
        ? of({code: 1, errorCode: null, messages: [], data: {result: opts.excelData}})
        : defer(() => opts.service[opts.func]({...params}) as Observable<IResponseApi<any>>);
      return request.pipe(
        map(res => {
          if (!res) throw new Error('common.messages.invalidData');
          if (res.code !== 1) throw new V2ApiResponseError(res);
          if (!res.data || !Array.isArray(res.data.result)) throw new Error('common.messages.invalidData');
          return res.data;
        }),
        concatMap(data => {
          // excelData đã qua callback ở caller (ví dụ các dòng đang chọn).
          const records = hasLocalData ? data.result
            : this.flatMapCallbackFunc(data.result, opts.callbackFuncHandle, setting);
          const rows = this.buildGoogleSheetRows(records, columns, headers.length);
          if (typeof data.totalItems === 'number' && data.totalItems > 0) {
            progress.totalItems = data.totalItems;
          }
          progress.totalPages = isOnePage ? 1
            : (castInt(data.totalPages) || ceilDivision(progress.totalItems, pageSize));
          const next = data.next;
          const hasNext = !isOnePage && (isElasticSearch
            ? next != null && next !== false && next !== '' && (!Array.isArray(next) || next.length > 0)
            : page < progress.totalPages);

          const batches: IGoogleSheetExportCell[][][] = [];
          for (let offset = 0; offset < rows.length; offset += 250) {
            batches.push(rows.slice(offset, offset + 250));
          }
          return from(batches).pipe(
            concatMap(batch => defer(() => this.googleSheetService.exportData({
              businessId: setting.businessId,
              fileName: setting.fileNew.fileName,
              sheetName: setting.googleFile.spreadSheetNewTitle,
              spreadUrl: setting.typeUseFile === 2 ? setting.googleFile.spreadUrl : '',
              headers,
              rows: batch,
              spreadData,
            })).pipe(tap(res => {
              spreadData = res.data.spreadData;
              progress.spreadData = spreadData;
              progress.resultData = spreadData;
              progress.currentItem = (progress.currentItem ?? 0) + res.data.rowsWritten;
              this.progressPaginator.next({...progress});
            }))),
            defaultIfEmpty(null),
            last(),
            map(() => ({next, hasNext}))
          );
        }),
        tap(() => {
          progress.page++;
          this.progressPaginator.next({...progress});
        })
      );
    };

    defer(loadPage).pipe(
      expand(result => {
        if (!result.hasNext || !this.shouldContinue) return EMPTY;
        if (isElasticSearch) {
          const cursorKey = JSON.stringify(result.next);
          if (seenCursors.has(cursorKey)) throw new Error('common.messages.invalidData');
          seenCursors.add(cursorKey);
          params[API_NHANH_KEY.EL_PAGE] = result.next;
        } else {
          params.page = ++page;
        }
        return loadPage();
      }, 1),
      takeUntil(this.googleSheetExportStop$),
      finalize(() => {
        this.isGoogleSheetExporting = false;
        this.shouldContinue = false;
        if (this._refModalExportData && !progress.isDone) {
          this._refModalExportData.progressState.isExportSubmit = false;
        }
      })
    ).subscribe({
      complete: () => {
        if (!this.shouldContinue) return;
        if (!spreadData) {
          this.notifyService.warning('common.noData');
          return;
        }
        progress.isDone = true;
        this.progressPaginator.next({...progress});
      },
      error: (error: unknown) => {
        const response = error instanceof V2ApiResponseError ? error.response : null;
        this._handleErrorExportData({
          code: 0, errorCode: response?.errorCode ?? null, data: {} as IResExportDataGGS,
          messages: response?.messages ?? [
            error instanceof Error && error.message === 'common.messages.invalidData'
              ? 'common.messages.invalidData' : 'common.messages.systemError'
          ],
        }, progress);
      }
    });
  }

  private buildGoogleSheetRows(records: any[], columns: IDisplayColumn[], headerCount: number): IGoogleSheetExportCell[][] {
    return records.map(record => {
      if (!record || typeof record !== 'object') throw new Error('common.messages.invalidData');
      const values = Array.isArray(record) ? record : columns.map(col => {
        if (Object.prototype.hasOwnProperty.call(record, col.ref)) return record[col.ref];
        return col.ref.split('.').reduce((value, key) => value?.[key], record);
      });
      if (values.length !== headerCount) throw new Error('common.messages.invalidData');
      return values.map(value => {
        if (value == null) return '';
        if (typeof value === 'number') {
          if (!Number.isFinite(value)) throw new Error('common.messages.invalidData');
          return value;
        }
        if (typeof value === 'string' || typeof value === 'boolean') return value;
        return Array.isArray(value) ? value.join(', ')
          : typeof value === 'object' ? JSON.stringify(value) : String(value);
      });
    });
  }

  /**
   * Xử lý tab "Excel" lưu file tĩnh
   * */
  private onHandleExportTabExcel(opts: TFinalExportDataOpts, isElasticSearch = false): void {
    const {limitNumberExport} = opts;
    if ((limitNumberExport && opts.totalItems !== undefined) && opts.totalItems > limitNumberExport) {
      this.closeAllModal();
      this.notifyService.dialogWarning({
        message: 'common.exportExcelLimitNumber',
        size: 'md'
      })
      return;
    }

    this.startExcelPaging();

    const setting = opts.outputSetting;
    /*
    * - Page cuối cùng khi có nhiều page
    * - Page cuối khi xuất dữ liệu trang hiện tại
    * - Page cuối khi xuất dữ liệu các bản ghi đã chọn
    * */
    const isOnePage = opts.isOnePage === true;


    // Nếu xuất trang hiện tại thì lấy page hiện tại
    let pageStart = 1;
    let elPageStart: any[] = [];
    if (opts.pageStart && setting.pageSelection == 'recordPage') {
      if (Array.isArray(opts.pageStart)) {
        elPageStart = opts.pageStart;
      } else {
        pageStart = castInt(opts.pageStart);
      }
    }

    const params: any = {
      ...opts.params,
      format: "jsExcel",
      formatNewExportExcel: "excelStatic"
    }

    if (isElasticSearch) {
      params['size'] = opts.pageSize;
      params[API_NHANH_KEY.EL_PAGE] = elPageStart;
    } else {
      params['icpp'] = opts.pageSize;
      params['page'] = pageStart;
    }

    // Cấu hình export file excel
    let headers: string[] = opts.excelHeaders ? opts.excelHeaders : [];
    if (!headers.length) {
      headers = translateColumnNames(setting.columns, this.app);
    }
    // Lấy danh sách các ref của những cột được chọn (display: true)
    const displayRefs = setting.columns.filter(c => c.display).map(c => c.ref);

    const configs: IExportExcelAndLog = {
      fileName: setting.fileNew.fileName,
      sheetName: setting.fileNew.sheetName,
      notSuffixFileName: true,
      jsonData: [],
      heading: headers,
      header: displayRefs, // Truyền danh sách key để lọc dữ liệu
      typeExport: opts.typeLogExport
    }

    // Nếu đã có dữ liệu sẵn (ví dụ: các dòng đã chọn), thực hiện xuất luôn
    if (isArray(opts.excelData) && opts.excelData?.length) {
      configs.jsonData = opts.excelData;
      this.exportExcel(configs, {useFileNew: true});
      return;
    }

    /**
     * - Page đầu tiên:
     * + Kiểm tra dữ liệu
     * + Tạo file trên google sheets
     * + Trả thông tin data cần xử lý
     * */
    opts.service?.[opts.func](params).subscribe({
      next: (rsFirst: IResponseApi<IResExportDataGGS>) => {
        if (!rsFirst.code) {
          const processPaginatorError: IProgressPaginator = {
            totalPages: 0,
            totalItems: 0,
            pageSize: castInt(opts.pageSize),
            page: 1,
            isError: true,
          }
          return this._handleErrorExportData(rsFirst, processPaginatorError);
        }

        configs.jsonData = this.flatMapCallbackFunc(rsFirst.data.result, opts.callbackFuncHandle, setting);

        const totalItems = castInt(rsFirst.data.totalItems);
        let totalPages = castInt(rsFirst.data.totalPages);
        if (isElasticSearch) {
          totalPages = ceilDivision(totalItems, opts.pageSize)
        }

        const rangesNumber = createRangePage({
          page: pageStart,
          totalPages: totalPages - 1,
          totalItems: totalItems,
        });

        const processPaginator: IProgressPaginator = {
          totalPages: totalPages,
          totalItems: totalItems,
          pageSize: castInt(opts.pageSize),
          page: 1,
          isError: !rsFirst.code,
        }

        this.progressPaginator.next(processPaginator)

        // Xuất dữ liệu trang hiện tại thì export data luôn
        if (isOnePage || (totalPages <= 1 && (!isElasticSearch || !rsFirst.data.next || !rsFirst.data.next.length))) {
          return this.exportExcel(configs)
        }

        /**
         * - Queue pages
         * */
        let elPageExport: any[] = [];
        let lastExportId: string = rsFirst.data.lastExportId ? rsFirst.data.lastExportId : '';//item cuối cùng của request export trước đó
        if (rsFirst.data.next) {
          elPageExport = rsFirst.data.next;
        }

        const loadNextPage = (pageIndex: number, currentLastExportId: string, currentElPage: any[]) => {
          if (!this.shouldContinue) return;

          let isLastPage = false;
          if (isElasticSearch) {
            isLastPage = !currentElPage || currentElPage.length === 0;
          } else {
            isLastPage = pageIndex >= rangesNumber.length;
          }

          if (isLastPage) {
            this.exportExcel(configs);
            return;
          }

          if (isElasticSearch) {
            params[API_NHANH_KEY.EL_PAGE] = currentElPage;
          } else {
            params.page = rangesNumber[pageIndex];
          }
          params.lastExportId = currentLastExportId;
          params.totalPages = totalPages;

          opts.service?.[opts.func](params).subscribe({
            next: (res: IResponseApi<IResExportDataGGS>) => {
              if (!res.code) {
                return this._handleErrorExportData(res, processPaginator);
              }

              const nextElPage = res.data.next || [];
              const nextLastExportId = res.data.lastExportId || '';

              processPaginator.page = castInt(processPaginator.page) + 1;
              if (isElasticSearch) {
                // Tăng fake totalItems để progress bar di chuyển
                processPaginator.totalItems = castInt(processPaginator.totalItems) + (res.data.result ? res.data.result.length : 0);
              }
              this.progressPaginator.next(processPaginator);

              configs.jsonData = [
                ...configs.jsonData,
                ...this.flatMapCallbackFunc(res.data.result, opts.callbackFuncHandle, setting),
              ];

              loadNextPage(pageIndex + 1, nextLastExportId, nextElPage);
            }
          });
        };

        loadNextPage(0, lastExportId, elPageExport);
      }
    });
  }

  /**
   * Hàm tạo dữ liệu export có các tình huống phổ biến
   * - callbackFuncHandle trả 1 record
   * - callbackFuncHandle trả 1 array
   * => KQ cần xử lý dữ liệu về 1 array 1 cấp
   * */
  flatMapCallbackFunc(dataSource: any[], callbackFuncHandle: ICallbackFuncHandle, opts: IConfigExportDataGoogleSheet): any[] {
    if (!isArray(dataSource) || !dataSource) {
      return [];
    }
    return dataSource.flatMap(item => {
      const rsl = callbackFuncHandle(item, {
        setting: opts,
        excelService: this
      });
      return isArray(rsl) ? rsl : [rsl];
    })
  }

  private _handleErrorExportData(res: IResponseApi<IResExportDataGGS>, processPaginator: IProgressPaginator) {
    this._nextProgressError(processPaginator);
    this.subjectEvent$.next({
      type: 'error',
      res: res
    })
    // Giữ nguyên messages theo tên trường cho modal, chỉ làm phẳng bản dùng để hiện thông báo.
    const rawMessages: unknown = res.messages;
    const messages = typeof rawMessages === 'string' ? [rawMessages]
      : rawMessages && typeof rawMessages === 'object'
        ? Object.values(rawMessages).flat().filter(value => typeof value === 'string' && value)
        : [];
    return this.notifyService.error(messages.length ? messages : ['common.messages.systemError'])
  }

  private _nextProgressError(process: IProgressPaginator) {
    this.stopExcelPaging();
    process.isError = true;
    this.progressPaginator.next(process)
  }
}
